import { buildUrl } from '../lib/helpers/miscHelpers'
import { StringMap } from '../types/misc'
import { PARAMS } from './params'
import { SEARCH_PARAMS } from './searchParams'

export const ROUTES = {
  index: '/',

  /**
   * ---------------------------------------------------------------------------
   * Account
   * ---------------------------------------------------------------------------
   */
  _account: '/account',
  account: '/account',
  _updatePassword: '/account/update-password',
  updatePassword: '/account/update-password',

  /**
   * ---------------------------------------------------------------------------
   * Auth
   * ---------------------------------------------------------------------------
   */
  login: '/auth/login',
  logout: '/auth/logout',
  register: '/auth/register',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/reset-password/:token',

  /**
   * ---------------------------------------------------------------------------
   * Contacts
   * ---------------------------------------------------------------------------
   */
  _addContact: `/contacts/add`,
  addContact: (
    context: RouteContext<undefined, typeof SEARCH_PARAMS.addContact>,
  ) => buildUrl(ROUTES._addContact, context),

  _editContact: `/contacts/:${PARAMS.editContact.contactId}/edit`,
  editContact: (context: RouteContext<typeof PARAMS.editContact>) =>
    buildUrl(ROUTES._editContact, context),

  _contactList: '/contacts/list',
  contactList: (
    context?: RouteContext<undefined, typeof SEARCH_PARAMS.contactList>,
  ) => buildUrl(ROUTES._contactList, context),

  _contactDetails: `/contacts/:${PARAMS.contactDetails.contactId}/details`,
  contactDetails: (context: RouteContext<typeof PARAMS.contactDetails>) =>
    buildUrl(ROUTES._contactDetails, context),

  contacts: {
    add: '/contacts/add',
    edit: '/contacts/:contactId/edit',
  },

  /**
   * ---------------------------------------------------------------------------
   * Debug
   * ---------------------------------------------------------------------------
   */
  _debugSentry: '/debug/sentry-test',
  debugSentry: () => ROUTES._debugSentry,
  _debugRelease: '/debug/release',
  debugRelease: () => ROUTES._debugRelease,

  /**
   * ---------------------------------------------------------------------------
   * Tags
   * ---------------------------------------------------------------------------
   */
  _addTag: `/tags/add`,
  addTag: () => buildUrl(ROUTES._addTag),

  _tagDetails: `/tags/:${PARAMS.tagDetails.tagId}/details`,
  tagDetails: (context: RouteContext<typeof PARAMS.tagDetails>) =>
    buildUrl(ROUTES._tagDetails, context),

  _editTag: '/tags/:tagId/edit',
  editTag: (context: RouteContext<typeof PARAMS.editTag>) =>
    buildUrl(ROUTES._editTag, context),

  _tagList: '/tags/list',
  tagList: () => buildUrl(ROUTES._tagList),
}

type RouteContext<
  TParams extends StringMap | undefined = undefined,
  TSearchParams extends StringMap | undefined = undefined,
> = {
  params?: TParams extends StringMap ? TParams : undefined
  searchParams?: TSearchParams extends TSearchParams ? StringMap : undefined
}
